module.exports = __WEBPACK_EXTERNAL_MODULE__7671__;